// removed by extract-text-webpack-plugin
module.exports = {"sea-buckthron":"#faa634","container":"alipay_container_2g0oP","content":"alipay_content_2gUb7","ali-logo":"alipay_ali-logo_3gBZ5","ali":"alipay_ali_ir9Y3","lato-title":"alipay_lato-title_3LVa_ lato-title","lato-cover-orange":"alipay_lato-cover-orange_2HEtc lato-title"};


//////////////////
// WEBPACK FOOTER
// ./src/static/solution/alipay/alipay.css
// module id = 384
// module chunks = 4